import { Routes, Route, useLocation } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage'
import RegisterPage from './pages/RegisterPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import NewStrategyPage from './pages/NewStrategyPage'
import StrategyDetailPage from './pages/StrategyDetailPage'
import ManualTestPage from './pages/ManualTestPage'
import StrategiesPage from './pages/StrategiesPage'
import SettingsPage from './pages/SettingsPage'
import ProfilePage from './pages/ProfilePage'
import ButtonTestPage from './pages/ButtonTestPage'
import TestPage from './pages/TestPage'
import DemoLoginPage from './pages/DemoLoginPage'
import DemoHomePage from './pages/DemoHomePage'
import DemoStrategyDetailPage from './pages/DemoStrategyDetailPage'
import DemoManualTestPage from './pages/DemoManualTestPage'
import DemoBacktestPage from './pages/DemoBacktestPage'
import DemoLiveTrackingPage from './pages/DemoLiveTrackingPage'
import DemoResearchNotesPage from './pages/DemoResearchNotesPage'
import DemoSettingsPage from './pages/DemoSettingsPage'
import DemoProfilePage from './pages/DemoProfilePage'
import DemoNewStrategyPage from './pages/DemoNewStrategyPage'
import DemoStrategiesPage from './pages/DemoStrategiesPage'
import AnimatedBackground from './components/AnimatedBackground'
import ThemeToggle from './components/ThemeToggle'
import LogoutIndicator from './components/LogoutIndicator'
import Footer from './components/Footer'
import { useAuth } from './contexts/AuthContext'

function LogoutIndicatorWrapper() {
  const { isLoggingOut } = useAuth()
  return <LogoutIndicator isLoggingOut={isLoggingOut} />
}

function AppContent() {
  const location = useLocation()
  const isPublicPage = ['/login', '/register', '/forgot-password', '/demo-login'].includes(location.pathname)
  
  return (
    <div className="min-h-screen bg-transparent relative">
      <AnimatedBackground />
      <div className="hidden sm:block">
        <ThemeToggle />
      </div>
      <LogoutIndicatorWrapper />
      <Routes>
        {/* 公开路由 */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        
        {/* 受保护的路由 */}
        <Route path="/" element={
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        } />
        <Route path="/strategy/new" element={
          <ProtectedRoute>
            <NewStrategyPage />
          </ProtectedRoute>
        } />
        <Route path="/strategy/:id" element={
          <ProtectedRoute>
            <StrategyDetailPage />
          </ProtectedRoute>
        } />
        <Route path="/strategy/:strategyId/manual-test" element={
          <ProtectedRoute>
            <ManualTestPage />
          </ProtectedRoute>
        } />
        <Route path="/strategies" element={
          <ProtectedRoute>
            <StrategiesPage />
          </ProtectedRoute>
        } />
        <Route path="/settings" element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        } />
        <Route path="/profile" element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        } />
        
        {/* 测试路由 */}
        <Route path="/button-test" element={<ButtonTestPage />} />
        <Route path="/test" element={<TestPage />} />
        
        {/* Demo路由 */}
        <Route path="/demo-login" element={<DemoLoginPage />} />
        <Route path="/demo" element={<DemoHomePage />} />
        <Route path="/demo/strategy/:strategyId" element={<DemoStrategyDetailPage />} />
        <Route path="/demo/manual-test" element={<DemoManualTestPage />} />
        <Route path="/demo/new-strategy" element={<DemoNewStrategyPage />} />
        <Route path="/demo/strategies" element={<DemoStrategiesPage />} />
        <Route path="/demo/backtest" element={<DemoBacktestPage />} />
        <Route path="/demo/live-tracking" element={<DemoLiveTrackingPage />} />
        <Route path="/demo/notes" element={<DemoResearchNotesPage />} />
        <Route path="/demo/settings" element={<DemoSettingsPage />} />
        <Route path="/demo/profile" element={<DemoProfilePage />} />
      </Routes>
      {!isPublicPage && <Footer />}
    </div>
  )
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  )
}

export default App 